import React from "react";
import { Card } from "antd";

const Visa = ({ img1, img2, color }) => {
  return (
    <>
      <Card
        className="flex flex-row justify-center items-center w-24.6 h-8.7"
        style={{
          backgroundColor: color,
        }}
      >
        <img className="visa-image1" src={img1} alt="Visa Card" />
        {img2 ? <img alt="master" src={img2} /> : ""}
      </Card>
    </>
  );
};

export default Visa;
